export const ROOM_ONBOARDING_MODES = {
  FULL: 'full',
  MEMORY: 'onboardedToRoomWithMemories',
  ROOM: 'onboardedToRoom'
}
